import { createContext } from 'react';

const ThreeContext = createContext(null);
export default ThreeContext;
